<template>
    <div>
      <div class="user">
        <div class="controlls">
          <i
              v-if="$store.getters.user.id !== user.id && user.id"
              class="el-icon-edit"
              @click="editUser"
          ></i>
          <i
              v-if="$store.getters.user.id !== user.id && user.id"
              class="el-icon-delete"
              @click="deleteUser"
          ></i>
        </div>
        <div class="user-data">
          <i class="el-icon-user ava"></i>
          <div><span>Login: </span><span>{{user.login}}</span></div>
          <div><span>Роль: </span><span>{{user.role.description}}</span></div>
        </div>
        <div class="assignments" v-if="selectedUser">
          <div>
            <h5>Категории</h5>
            <div class="category" v-for="cat in computedUserCategories">{{cat}}</div>
          </div>
          <div>
            <h5>Организации</h5>
            <div class="org" v-for="org in computedUserOrganizations">{{org.name}}</div>
          </div>
          <div>
            <h5>Интеграции</h5>
            <div class="int" v-for="int in computedUserIntegrations">{{int.name}}</div>
          </div>
        </div>





      </div>
      <el-dialog
          :visible.sync="openUserDialog"
          width="65%"
          title="Редактирование пользователя"
      >
        <div class="user-edit">
          <el-form
              v-if="selectedUser"
              label-position="'right'"
              :model="selectedUser"
          >
            <div class="user-scroll">
              <el-form-item label="Логин">
                <el-input v-model="selectedUser.login"></el-input>
              </el-form-item>
              <el-form-item label="Фамилия">
                <el-input v-model="selectedUser.first_name"></el-input>
              </el-form-item>
              <el-form-item label="Имя">
                <el-input v-model="selectedUser.last_name"></el-input>
              </el-form-item>
              <el-form-item label="Отчество">
                <el-input v-model="selectedUser.patronym"></el-input>
              </el-form-item>
              <el-form-item label="E-mail">
                <el-input v-model="selectedUser.email"></el-input>
              </el-form-item>
              <el-form-item label="Роль">
                <el-select v-model="selectedUser.role.name">
                  <el-option
                      v-for="role in roles"
                      :key="role.name"
                      :label="role.description"
                      :value="role.name"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="Новый пароль">
                <el-input type="password" v-model="selectedUser.new_password"></el-input>
              </el-form-item>
              <el-form-item label="Подтверждение пароля">
                <el-input type="password" v-model="selectedUser.new_password_confirm"></el-input>
              </el-form-item>
            </div>
            <div class="user-fixed">
              <el-form-item label="Активен">
                <el-switch
                    :disabled="$store.getters.user.id === user.id && user.role.name !== 'admin'"
                    v-model="selectedUser.status"
                    :active-value="1"
                    :inactive-value="0"
                ></el-switch>
              </el-form-item>
              <div class="other">
                <el-form-item label="Категории">
                  <i class="el-icon-edit" @click="categoryDialog = true"></i>
                  <div class="categories" v-if="selectedUser.categories">
                    <ul>
                      <li v-for="category in selectedUser.categories"
                          :key="category.id">
                        {{category.category.name}}
                      </li>
                    </ul>
                  </div>
                  <div class="categories" v-else><span>Назначения отсутствуют</span></div>
                  <el-dialog title="Принадлежность пользователя к категории" :visible.sync="categoryDialog">
                    <el-tree
                        :data="prepareLocations"
                        show-checkbox
                        default-expand-all
                        node-key="category_id"
                        ref="user-locations-tree"
                        highlight-current
                        :props="defaultPropsLocations"
                        :default-checked-keys="checkedUserCategories"
                    >
                    </el-tree>
                    <el-row type="flex" justify="end">
                      <el-button @click="categoryDialog = !categoryDialog">Отменить</el-button>
                      <el-button type="primary" @click="saveUserCategories">Сохранить</el-button>
                    </el-row>
                  </el-dialog>
                </el-form-item>
                <el-form-item label="Организации">
                  <i class="el-icon-edit" style="opacity: 0;"></i>

                  <div>
                    <el-checkbox-group v-model="selectedUser.organizations">
                        <el-checkbox
                            v-for="org in organizations"
                            :label="org.id"
                            :key="org.id"
                        >
                          {{ org.name }}
                        </el-checkbox>
                    </el-checkbox-group>
                  </div>

                </el-form-item>
                <el-form-item label="Интеграции">
                  <i class="el-icon-edit" style="opacity: 0;"></i>

                  <div>
                    <el-checkbox-group v-model="selectedUser.integrations">
                        <el-checkbox
                            v-for="int in integrations"
                            :label="int.name"
                            :key="int.name"
                        >
                          {{int.name}}
                        </el-checkbox>
                    </el-checkbox-group>
                  </div>
                </el-form-item>
              </div>

              <el-form-item style="text-align: right">
                <el-button
                    type="primary"
                    @click="save(selectedUser)"
                >
                  {{user.id? 'Изменить': 'Сохранить'}}
                </el-button>
              </el-form-item>
            </div>


          </el-form>
        </div>
      </el-dialog>
    </div>
</template>
<script>
export default {
  name: "organization-user",
  props: {
    user: {},
    organizationId:{},
    organizations: {},
    integrations: {},
    roles:{},
    prepareLocations: {},
    newUser: {
      Type: Boolean,
      defaultValue: false
    }
  },
  data() {
    return {
      openUserDialog:false,
      categoryDialog:false,
      integrationsDialog:false,
      organizationsDialog:false,
      selectedUser: {
          id: null,
          login: null,
          first_name: null,
          last_name: null,
          patronym: null,
          integrations: [],
          organizations: [],
          categories: [],
          email: null,
          status: 1,
          role: {
            name: 'user'
          },

        },
      defaultPropsLocations: []
    }
  },
  mounted() {

  },
  watch :{
    newUser(newValue, oldValue) {
      this.openUserDialog = !!this.newUser
      if(this.newUser) {
        this.selectedUser = {
          id: null,
          login: null,
          first_name: null,
          last_name: null,
          patronym: null,
          organization_id: this.organizationId,
          integrations: [],
          organizations: [],
          email: null,
          status: 1,
          role: {
            name: 'user'
          },
          categories: []
        }
      }

    }
  },
  computed:{
    checkedUserCategories() {
      return this.user.categories
          ? this.user.categories.map( category => category.category_id)
          : [];
    },
    computedUserCategories() {
      return this.selectedUser.categories
          ? this.selectedUser.categories.map( category => category.category.name)
          : [];
    },
    computedUserOrganizations() {
      if(!this.user.organizations.length || this.newUser) {
        return []
      }

      return this.organizations.filter(org => this.user.organizations.includes(org.id));
    },
    computedUserIntegrations() {
      if(!this.user.integrations.length || this.newUser) {
        return []
      }

      return this.integrations.filter(int => this.user.integrations.includes(int.name));
    }
  },
  methods :{
    checkedOrganization(id) {
      if(!this.selectedUser.organizations || this.newUser) {
        return false
      }
      return this.organizations.includes(id)
    },
    checkedIntegration(name) {
      if(!this.selectedUser.integrations || this.newUser) {
        return false
      }
      return this.integrations.includes(name)
    },
    editUser() {
      this.openUserDialog = true
      if(this.newUser) {
        return this.selectedUser
      }
      this.selectedUser = this.user
      // this.selectedUser = {
      //   ...this.user,
      //   organizations: Array.isArray(this.user.organizations) ? this.user.organizations : [],
      //   integrations: Array.isArray(this.user.integrations) ? this.user.integrations : [],
      // };
    },
    save() {
      this.selectedUser.role = this.selectedUser.role.name;
      this.selectedUser.organization_id = this.organizationId;

      this.$api.management.saveUser(this.selectedUser)
          .then(data => {
            if(!data.errors) {
              this.$notify.success({
                duration: this.$constants.global.notifyDurationError,
                title: 'Успешно',
                message: 'Данные сохранены',
              });
            }else{
              this.$notify.error({
                duration: this.$constants.global.notifyDurationError,
                title: 'Ошибка',
                message: data.errors,
              });
            }
            this.$emit('update')
          })
          .finally(() => {
            this.openUserDialog = false
            this.formDrawer = false;
            this.loading = true;
          })
    },
    deleteUser(){
      this.$api.management.deleteUser({id: this.user.id})
          .then(data => {
            if(!data.errors) {
              this.$notify.success({
                duration: this.$constants.global.notifyDurationError,
                title: 'Успешно',
                message: 'Данные сохранены',
              });
            }else{
              this.$notify.error({
                duration: this.$constants.global.notifyDurationError,
                title: 'Ошибка',
                message: data.errors,
              });
            }
            this.$emit('update')
          })
          .finally(() => {
            this.formDrawer = false;
            this.loading = true;
          })

    },
    getAvailableRoles() {
      if(!this.$store.getters.user.id) {

      }
      this.$api.management.getAvailableRoles(
          {id: this.$store.getters.user.id}
      )
          .then(data => {
            this.roles = data;
          })
    },
    saveUserCategories() {

      let categories = this.$refs["user-locations-tree"].getCheckedKeys().filter(function( element ) {
        return element !== undefined;
      });

      this.$api.management.saveUserCategories({
        organization_id: this.organizationId,
        user_id: this.user.id,
        categories: categories
      })
          .then(data => {
            if(!data.errors) {
              this.$notify.success({
                duration: this.$constants.global.notifyDurationError,
                title: 'Успешно',
                message: 'Данные сохранены',
              });

            }else{
              this.$notify.error({
                duration: this.$constants.global.notifyDurationError,
                title: 'Ошибка',
                message: data.errors,
              });
            }
          })
          .finally(() => {
            this.categoryDialog = false
            this.$emit('update', this.organizationId)
          })

    }
  }
}
</script>
<style scoped lang="scss">
.other {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: .5rem;
  > * {
    border: 1px solid #ddd;
    border-radius: 4px;
    background: #fafafa;
    padding: .5rem 1rem;
  }
  .el-checkbox {
    display: block;
  }
}
.user {
  position: relative;
  .el-icon-user.ava {
    position: absolute;
    font-size: 40px;
    right: 25px;
    margin-top: 3px;
  }

  height: 40vh;
  overflow: hidden;

  h5 {
    color: #322323;
  }
  .controlls {
    display: flex;
    justify-content: space-between;
    border-radius: 5px;
    padding: .5rem;
    i {
      color: #000;
      cursor: pointer;
      &:hover{
        scale: 1.3;
      }
    }
  }
  .user-data {
    margin: .4rem;
    padding:.5rem 1rem;
    border: 1px solid #d1dbe5;
    border-radius: 4px;
    div {
      > span {
        color: #323232;
        &:last-child {
          font-weight: 700;
        }
      }
    }
  }
  .assignments {
    display: flex;
    font-size: 10px;
    justify-content: space-around;
    gap: .5rem;
    > div {
      width: calc(50% - 1rem);
      border: 1px solid #d1dbe5;
      border-radius: 4px;
      padding: 1rem;
      color: #404040;
      > div  {
        margin-bottom: .5rem;
        border-bottom: 1px solid #8f8f8f;
      }
    }
  }
}
.user-edit {
  padding: 2rem;
}
</style>